/*
 * @Descripttion:
 * @version:
 * @@Company: HDWB
 * @Author: cwl
 * @Date: 2022-04-11 13:43:43
 * @LastEditors: cwl
 * @LastEditTime: 2023-07-17 17:32:01
 */
/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */

let baseUrl = "";
let routerMode = "history";
let imgBaseUrl = "";

if (process.env.NODE_ENV == "development") {
  // 	imgBaseUrl = 'http://www.tibetmuseum.com.cn/';
  // baseUrl = 'http://www.tibetmuseum.com.cn/api';
  // imgBaseUrl = 'https://xzwww.hengdawenbo.com'
  imgBaseUrl = process.env.VUE_APP_IMG_BASE_URL;
  baseUrl = process.env.VUE_APP_BASE_URL + "/api";
} else if (process.env.NODE_ENV == "production") {
  imgBaseUrl = "";
  baseUrl = "/api";
  // imgBaseUrl = 'http://192.168.10.158:8217';
  // baseUrl = 'http://192.168.10.158:8217/api';
}

export { baseUrl, routerMode, imgBaseUrl };



// WEBPACK FOOTER //
// ./src/config/url.js